import { useEffect, useState } from 'react';
import { Alert, Container, Grid, Skeleton, Stack, Tab, Tabs, Typography } from '@mui/material';

import quotesApi from '../../api/quotesApi';
import useCart from '../../cart/useCart';
import ProductCard from '../../sections/client/products/ProductCard';

// Filtros de la pestaña: "todas" pide ofertas y remates juntos (?offers=1), los otros dos
// filtran por offer_type (ver ProductCatalogController en la API).
const FILTERS = [
  { value: 'todas', label: 'Todas' },
  { value: 'oferta', label: 'Ofertas' },
  { value: 'remate', label: 'Remates y saldos' },
];

// Pestaña "Ofertas" de la tienda: productos marcados en oferta o en remate (saldos) desde
// el formulario de producto del panel.
export default function OffersPage() {
  const { addItem, openDrawer } = useCart();

  const [filter, setFilter] = useState('todas');
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(false);

    quotesApi
      .getCatalogProducts({
        offers: 1,
        offer_type: filter === 'todas' ? undefined : filter,
        limit: 50,
      })
      .then(({ data }) => active && setProducts(data.data))
      .catch(() => active && setError(true))
      .finally(() => active && setLoading(false));

    return () => {
      active = false;
    };
  }, [filter]);

  const handleAddToCart = (product, quantity) => {
    addItem(product, quantity);
    openDrawer();
  };

  return (
    <Container maxWidth="lg" sx={{ py: 5 }}>
      <Stack spacing={1} sx={{ mb: 3 }}>
        <Typography variant="h4">Ofertas</Typography>
        <Typography color="text.secondary">Productos en oferta y remates de saldos, hasta agotar stock.</Typography>
      </Stack>

      <Tabs value={filter} onChange={(e, value) => setFilter(value)} sx={{ mb: 4 }} variant="scrollable" allowScrollButtonsMobile>
        {FILTERS.map((option) => (
          <Tab key={option.value} value={option.value} label={option.label} />
        ))}
      </Tabs>

      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          No se pudieron cargar las ofertas. Intenta nuevamente.
        </Alert>
      )}

      {!loading && !error && products.length === 0 && (
        <Alert severity="info">Por ahora no hay productos en esta sección. ¡Vuelve pronto!</Alert>
      )}

      <Grid container spacing={3}>
        {loading
          ? Array.from({ length: 8 }).map((_, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <Grid key={index} size={{ xs: 12, sm: 6, md: 3 }}>
                <Skeleton variant="rounded" height={220} />
              </Grid>
            ))
          : products.map((product) => (
              <Grid key={product.id} size={{ xs: 12, sm: 6, md: 3 }}>
                <ProductCard product={product} onAddToCart={handleAddToCart} />
              </Grid>
            ))}
      </Grid>
    </Container>
  );
}
